module.exports = __webpack_public_path__ + "img/chart-to-settings.b0c003d3.svg";